import Helper from '@lovata/popup-helper';

export default new class NavigationDrawer {
  constructor() {
    this.hiddenSelector = 'drawer-nav__wrapper_hidden';
    this.drawerNavSelector = 'drawer-nav';
    this.drawerOpenNavSelector = 'drawer-nav_open';
    this.drawerBtnSelector = 'drawer__btn';
    this.drawerCloseBtnSelector = 'drawer-nav__btn';
    this.drawerControllerBtn = 'js-drawer-btn';
    this.drawerCloseBtnVisibleSelector = 'drawer-nav__btn_close';
    this.subNavHeaderSelector = 'header-nav__title';
    this.subNavHeaderOpenSelector = 'header-nav__title_open';
    this.subNavListSelector = 'drawer-nav__category';
    this.subNavListOpenSelector = 'drawer-nav__category_open';

    this.buttonOpenParrent = 'js-drawer-nav-open-parent';
    this.buttonOpenReturn = 'js-drawer-nav-return-back';
    this.drawerNavAjaxWrapper = 'js-drawer-nav__list-wrapper';
    this.idSelector = 'data-category-id';

    this.drawerWrapperSelector = 'drawer-nav__wrapper';

    this.handler();
    this.engineMobileMenu();
  }

  handler() {
    $(document).on('click', `.${this.drawerControllerBtn}`, ({ currentTarget }) => {
      const isOpen = $(currentTarget).hasClass(this.drawerCloseBtnVisibleSelector);
      const wrapper = $(`.${this.drawerWrapperSelector}`);
      const modal = document.querySelector(`.${this.drawerNavSelector}`);
      const openBtn = document.querySelector(`.${this.drawerBtnSelector}`);
      const focusTarget = isOpen ? $(`.${this.drawerCloseBtnSelector}`)[0] : openBtn;

      Helper.overlayHandler(!isOpen, focusTarget, modal);
      Helper.setBodyScrollState(isOpen);

      $(`.${this.drawerControllerBtn}`).toggleClass(this.drawerCloseBtnVisibleSelector);
      wrapper.toggleClass(this.hiddenSelector);
      $(`.${this.drawerNavSelector}`).toggleClass(this.drawerOpenNavSelector);

      Helper.focusTrapManager(!isOpen, modal);
    });

    $(document).on('click', `.${this.subNavHeaderSelector}`, ({ currentTarget }) => {
      const list = $(currentTarget).siblings(`.${this.subNavListSelector}`);

      if (!list.length) return;

      $(currentTarget).toggleClass(this.subNavHeaderOpenSelector);
      list.toggleClass(this.subNavListOpenSelector);
    });
  }

  engineMobileMenu() {
    $(document).on('click', `.${this.buttonOpenParrent}`, (el) => {
      el.preventDefault();

      const { target } = el;
      const id = target.getAttribute(this.idSelector);

      if (!id) return;

      this.ajaxLoadElement(id);
    });
    // eslint-disable-next-line sonarjs/no-identical-functions
    $(document).on('click', `.${this.buttonOpenReturn}`, (el) => {
      el.preventDefault();

      const { target } = el;
      const id = target.getAttribute(this.idSelector);

      if (!id) return;

      this.ajaxLoadElement(id);
    });
  }

  ajaxLoadElement(id) {
    $.request('CategoryList::onAjaxRequest', {
      data: {
        category_id: id,
      },
      update: { 'header/drawer-nav/drawer-nav-list': `.${this.drawerNavAjaxWrapper}` },
      success: function (res) { // eslint-disable-line object-shorthand, func-names
        this.success(res);
      },
    });
  }
}();
